function assertPositiveInt(value, owner) {
    if (!Number.isInteger(value) || value <= 0) {
        throw new Error(`${owner}: amount должен быть положительным целым`);
    }
}
function effect(run, dependencies = []) {
    return Object.freeze({
        source: 'card_effect',
        dependencies: Object.freeze(dependencies.map(({ id }) => Object.freeze({ id }))),
        run,
    });
}
function resolvePlayer(ctx, player) {
    if (typeof player === 'function')
        return player(ctx);
    return player ?? ctx.self?.controllerId;
}
export function drawCards(count, player) {
    assertPositiveInt(count, 'drawCards');
    return effect((ctx) => {
        const playerId = resolvePlayer(ctx, player);
        if (playerId !== undefined)
            ctx.ops.drawCard(playerId, count);
    });
}
export function addSelfHeat(amount) {
    assertPositiveInt(amount, 'addSelfHeat');
    return effect((ctx) => {
        if (ctx.self !== undefined)
            ctx.ops.addHeat(ctx.self.id, amount);
    });
}
export function createCardInHand(card, player) {
    if (card.id.length === 0)
        throw new Error('createCardInHand: card id должен быть непустой строкой');
    return effect((ctx) => {
        const playerId = resolvePlayer(ctx, player);
        if (playerId !== undefined)
            ctx.ops.createCardInHand(card.id, playerId);
    }, [card]);
}
//# sourceMappingURL=effects.js.map